// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_NO_RESULTS = "Zatia\u013e nem\u00e1\u0161 ulo\u017een\u00e9 \u017eiadne ko\u010d\u00edky.";
